.filter {
	position: relative;
}

.closeIcon {
	all: unset;
	cursor: pointer;
	width: 16px;
	height: 16px;
	color: var(--content-tertiary);
	position: absolute;
	right: 12px;
	top: 50%;
	transform: translateY(-50%);
	display: flex;
	align-items: center;
	justify-content: center;
	z-index: 1;
}

.closeIcon:focus-visible {
	outline: var(--focus-outline);
	outline-offset: var(--focus-outline-offset);
}
